import { render, staticRenderFns } from "./InteractiveTextComponent.vue?vue&type=template&id=9473598c&scoped=true"
import script from "./InteractiveTextComponent.vue?vue&type=script&lang=js"
export * from "./InteractiveTextComponent.vue?vue&type=script&lang=js"
import style0 from "./InteractiveTextComponent.vue?vue&type=style&index=0&id=9473598c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9473598c",
  null
  
)

export default component.exports